import { useSuspenseQuery } from '@tanstack/react-query';
import { eSimProductsQueries } from '../../utils/esimProductsQueries';
import { fetchESim } from '../api/eSimApi';

type UseESimDetailProps = {
  eid: string;
};
export const useESimDetail = ({ eid }: UseESimDetailProps) => {
  return useSuspenseQuery({
    queryKey: eSimProductsQueries.esim({ eid }),
    queryFn: () => fetchESim({ eid }),
    refetchOnWindowFocus: false,
  });
};
